// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"84c7e66a","940":"409b3c66"}[chunkId] + ".chunk.js");